import React from 'react';
import './App.css';

import {Overview} from './Components/Overview/overview.js';

function App() {
  return (
    <div>
      <Overview />
    </div>
  );
}

export default App;